import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouseUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.9937 10.9875C18.525 10.9875 18.9937 10.55 18.9937 9.98438C19.025 9.70312 18.9 9.45312 18.65 9.23438L17 7.78125V4C17 3.44687 16.5531 3 16 3H15C14.4469 3 14 3.44687 14 4V5.14687L10.6719 2.21875C10.4844 2.0625 10.2344 2 10.0156 2C9.79688 2 9.54688 2.03125 9.32812 2.25L1.3125 9.23438C1.09375 9.45312 1 9.70312 1 9.98438C1 10.5469 1.4375 10.9875 2 10.9875H3V16C3 17.1031 3.89687 18 5 18H15.0156C16.125 18 17.0219 17.1 17.0156 15.9906L16.9937 10.9844H17.9937V10.9875ZM10 7C10.5304 7 11.0391 7.21071 11.4142 7.58579C11.7893 7.96086 12 8.46957 12 9C12 9.53043 11.7893 10.0391 11.4142 10.4142C11.0391 10.7893 10.5304 11 10 11C9.46957 11 8.96086 10.7893 8.58579 10.4142C8.21071 10.0391 8 9.53043 8 9C8 8.46957 8.21071 7.96086 8.58579 7.58579C8.96086 7.21071 9.46957 7 10 7ZM6.5 14.5C6.5 13.1187 7.61875 12 9 12H11C12.3813 12 13.5 13.1187 13.5 14.5C13.5 14.775 13.275 15 13 15H7C6.725 15 6.5 14.775 6.5 14.5Z",
		fill: "#0D2976"
	})
});
export default SvgHouseUser;
